import { PDFViewer } from '@react-pdf/renderer';
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { Modal } from '../../../../../component';
import { useTypedSelector } from '../../../../../hooks/useTypedSelector';
import { studiesSelector } from '../../redux/studies.reducer';
import { modalOpen } from '../../../redux/dashboardActions';
import { ViabilityReport } from './viabilityReport';
import { ImgUrls, usePDFData } from './usePDFData';

export const RenderPDFReport: React.FC = () => {
  const { statusModal } = useTypedSelector((state) => state.dashboardState);
  const dispatch = useDispatch();
  const {
    absorptionAndLiquidityResponsePrimary,
    layoutsValuationPayload,
    layoutsValuationPrimaryResponse,
    layoutsValuationSecondaryResponse,
    installmentsSimulationPrimary,
    installmentsSimulationSecondary,
    studyName,
    creationDate,
    id,
    polygon,
    expandedArea,
  } = useTypedSelector(studiesSelector);
  const { imgURLs, layoutsFormattedData } = usePDFData({
    polygon,
    expandedArea,
    layoutCharacteristics: layoutsValuationPayload ?? null,
    layoutValuationResponsePrimary: layoutsValuationPrimaryResponse,
    layoutValuationResponseSecondary: layoutsValuationSecondaryResponse,
    absorptionAndLiquidity: absorptionAndLiquidityResponsePrimary,
    installmentsSimulationPrimary: installmentsSimulationPrimary,
    installmentsSimulationSecondary: installmentsSimulationSecondary,
  });
  const [mapImageUrl, setMapImageUrl] = useState<[string, string] | [string]>(
    imgURLs.polygon ? [imgURLs.polygon] : ['', '']
  );
  const headerInfo = {
    studyName,
    creationDate,
    id,
  };

  const mapImages: ImgUrls = [imgURLs.polygon, imgURLs.expandedArea];

  return (
    <Modal
      open={statusModal === 'render pdf preview'}
      close={() => dispatch(modalOpen(''))}
      cy="PDFPreview"
      title=""
      size="large-full"
    >
      <div style={{ width: '100%', height: '100vh' }}>
        {layoutsFormattedData && (
          <PDFViewer style={{ width: '100%', height: '100%' }}>
            <ViabilityReport
              imageSources={mapImages}
              layoutsFormattedData={layoutsFormattedData}
              headerInfo={headerInfo}
            />
          </PDFViewer>
        )}
      </div>
    </Modal>
  );
};
